import React, { useEffect, useState } from "react";
import { LookupService } from "../../../app/core/lookup.service";
import { DataTable } from "../../../components/data-table";
import { LogsGridData } from "./data-grid-cols";
export const LogsData = () => {
  const [loading, setLoading] = useState(false);
  const [logsData, setLogsData] = useState<any>([]);
  const [filteredLogs, setFilteredLogs] = useState<any>([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [pageCount,setPageCount] = useState<any>();

  useEffect(() => {
    getLogs();
  }, []);

  useEffect(() => {
    if (selectedDate) {
      const filtered = logsData.filter((log: any) => {
        const match = log.file_name.match(/\d{4}-\d{2}-\d{2}/);
        return match && match[0] === selectedDate;
      });
      setFilteredLogs(filtered);
    } else {
      setFilteredLogs(logsData);
    }
  }, [selectedDate, logsData]);

  const getLogs = async () => {
    setLoading(true);
    try {
      const featureGroups = await LookupService.getLogsData();
      const transformedData = [...featureGroups].reverse().map((file, index) => ({
          id: index + 1,
          file_name: file,
          link: file,
        }));
      setLogsData(transformedData);
      setFilteredLogs(transformedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error, "error");
    }
  };

  const onHandleDate = (target: any) => {
    setSelectedDate(target.value);
  };

  const handleClear = () => {
    setSelectedDate("");
  };

  const onSelectPaginator = (data: any) => {
    const pageData = pageCount;
    pageData.page = data;
    setPageCount(pageData);
    // getOndcIgmData(pageCount);
  };

  return (
    <div className="container-fluid content-bg-color">
      <h4 className="primary-color fw-bold mt-3">All Server Logs</h4>
      <div className="row mb-2 align-items d-flex">
        <div className="col-md-4">
          <input
            type="date"
            className="form-control"
            value={selectedDate}
            onChange={(e) => onHandleDate(e.target)}
          />
        </div>
        <div className="col-md-2 d-flex">
          <button
            className="primary-bg primary-border text-white w-50 py-1 rounded ms-1"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </div>
      {loading && (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}
      {!loading && (
        <div className="row">
          <DataTable tableData={filteredLogs} TableCols={LogsGridData} pagination={true} pageCount={pageCount} onSelectPageChange={(e) => onSelectPaginator(e)}/>
        </div>
      )}
    </div>
  );
};
